@if (isLoading) {
  <mat-spinner></mat-spinner>
}

<app-generic-filter-selector
  [availableFilters]="availableChaptersToFilters$ | async"
  (filterClick)="onChapterFilterSelected($event)"
  [extraContextInfoForAccessibility]="'accessibility.chapter_filter' | translate"
></app-generic-filter-selector>